// extracted by mini-css-extract-plugin
export default {"card":"Card_card__-SwHU","cardImage":"Card_cardImage__O5c+i"};